import * as RadixTooltip from '@radix-ui/react-tooltip';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router';
import { ToastContainer } from 'react-toastify';

import ErrorBoundary from '@/shared/error/ErrorBoundary';
import { defaultValue, ErrorContext } from '@/shared/error/ErrorContext';

import { Routes } from './model/routes';
import { store } from './model/store';
import { AntdConfigProvider } from './providers/AntdConfigProvider';
import { IntlProvider } from './providers/IntlProvider';

export const App = () => (
  <ErrorContext.Provider value={defaultValue}>
    <Provider store={store}>
      <IntlProvider>
        <AntdConfigProvider>
          {/* Inside the locale providers so the ErrorPage fallback is localized. */}
          <ErrorBoundary>
            <RadixTooltip.Provider>
              <Router>
                <Routes />
                <ToastContainer icon={false} hideProgressBar />
              </Router>
            </RadixTooltip.Provider>
          </ErrorBoundary>
        </AntdConfigProvider>
      </IntlProvider>
    </Provider>
  </ErrorContext.Provider>
);
